import styled from "@emotion/styled";
import { TypedSearchResultDataValue } from "./../utils";
import { getIcon } from "./../icon-factory";
import { formatters } from "@kaltura/mediaspace-shared-utils";
import { Link, Typography } from "@kaltura/ds-react-components";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

export interface TimedSearchResultProps {
    data: TypedSearchResultDataValue;
    mediaUrl: string;
    baseClassName: string;
}

const StyledTimedSearchResult = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 0),
    alignItems: "center",
}));

const StyledLink = styled(Link)(({ theme }) => ({
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(18),
}));
const StyledTypography = styled(Typography)({
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
});

export function TimedSearchResult({ data, mediaUrl, baseClassName }: TimedSearchResultProps) {
    const icon = getIcon(data.type);
    const time = Math.floor((data.startTime ?? 0) / 1000); // convert ms to seconds
    const formattedTime = data.startTime ? formatters.formatSecondsToTime(time) : 0;
    const url = `${mediaUrl}?st=${time}`;

    const sendButtonAnalytics = useButtonAnalytics();
    const sendAnalytics = () => {
        sendButtonAnalytics("Explore sidebar - Timestamp clicked", ButtonClickAnalyticsType.LINK);
    };

    return (
        <StyledTimedSearchResult className={`${baseClassName}-explore-reasons-item`}>
            {icon}
            <StyledLink href={url} onClick={sendAnalytics}>
                {formattedTime}
            </StyledLink>
            <StyledTypography variant={"body2"}>{data.text}</StyledTypography>
        </StyledTimedSearchResult>
    );
}

export default TimedSearchResult;
